import { FormProps, Form, Button } from 'antd';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

export const SequencesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  font-family: Nunito;
  font-style: normal;
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 1rem;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 6.875rem;
  margin-bottom: 1rem;
`;

export const Enumerator = styled.div`
  width: 3.313rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const EnumeratorItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 0.063rem solid rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  border-radius: 2rem;
  width: 2rem;
  height: 2rem;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.5rem;
  color: rgba(0, 0, 0, 0.65);
`;

export const Sequence = styled.div<{ deleting: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 6.875rem;
  box-shadow: 0 0.063rem 0.25rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  cursor: default;
  opacity: ${(s) => (s.deleting ? 0.4 : 1)};
  border: ${(s) => (s.deleting ? '1px solid #FF4D4F' : 'unset')};
`;

export const SequenceForm: FunctionComponent<FormProps> = styled(Form)`
  padding: 2rem;
  width: 100%;
  .ant-form-item {
    display: inline-block;
    flex: 0 0 12rem;
    margin-right: 1.875rem;
  }

  label::after {
    content: none;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
`;

export const DragArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 3rem;
  background: rgba(0, 0, 0, 0.04);
  .anticon {
    color: rgba(0, 0, 0, 0.45);
  }
  cursor: grab;
`;

export const DeleteArea = styled(DragArea)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
`;

export const DeleteZone = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 2.75rem;
  height: 2.75rem;
  justify-self: flex-end;
`;

export const FieldsArea = styled.div`
  width: 100%;
`;

export const AddSequence = styled(Button)`
  height: 4.5rem;
`;

export const SaveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 1.875rem;

  button {
    border-radius: 0.125rem;
    height: 2rem;
    display: flex;
    align-items: center;
    span {
      font-family: Nunito;
      font-style: normal;
      font-weight: bold;
      font-size: 0.875rem;
      line-height: 1.375rem;
    }
  }
`;

export const GridEmptyRow = styled.div`
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  -webkit-font-feature-settings: 'tnum';
  font-feature-settings: 'tnum', 'tnum';
  margin-bottom: 1.5rem;
  vertical-align: top;
`;
